if (!customElements.get('platane-product-carousel')) {
  customElements.define('platane-product-carousel', class PlataneProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.items = Array.from(this.querySelectorAll('[data-carousel-item]'));
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.currentLabel = this.querySelector('[data-carousel-current]');
      this.totalLabel = this.querySelector('[data-carousel-total]');
      this.autoplaySeconds = Number(this.dataset.autoplaySeconds || 0);
      this.currentPage = 0;
      this.autoplayTimer = null;

      if (!this.viewport || this.items.length === 0) return;

      this.previousButton?.addEventListener('click', () => this.goTo(this.currentPage - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentPage + 1));
      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
      this.handleVisibilityChange = () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      };
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
      } else {
        this.handleResize = () => this.update();
        window.addEventListener('resize', this.handleResize, { passive: true });
      }
      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.resizeObserver?.disconnect();
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
      if (this.handleVisibilityChange) document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    get visibleCount() {
      if (!this.items[0]) return 1;
      return Math.max(1, Math.round(this.viewport.clientWidth / this.items[0].getBoundingClientRect().width));
    }

    get pageCount() {
      return Math.max(1, Math.ceil(this.items.length / this.visibleCount));
    }

    update() {
      this.currentPage = Math.min(this.currentPage, this.pageCount - 1);
      if (this.totalLabel) this.totalLabel.textContent = String(this.pageCount).padStart(2, '0');
      this.updateLabel();
    }

    updateLabel() {
      if (this.currentLabel) this.currentLabel.textContent = String(this.currentPage + 1).padStart(2, '0');
    }

    goTo(page) {
      const count = this.pageCount;
      this.currentPage = (page + count) % count;
      this.viewport.scrollTo({
        left: this.currentPage * this.viewport.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      this.updateLabel();
    }

    onScroll() {
      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = window.requestAnimationFrame(() => {
        if (!this.viewport.clientWidth) return;
        this.currentPage = Math.min(this.pageCount - 1, Math.max(0, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
        this.updateLabel();
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.autoplaySeconds < 3 || this.pageCount < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.autoplayTimer = window.setInterval(() => this.goTo(this.currentPage + 1), this.autoplaySeconds * 1000);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  });
}
